const T = require("react").PropTypes;

const User = {
    /* For now, we only include props that we're actually using */
    PropType: T.shape({
        Login: T.string.isRequired,
        DisplayName: T.string.isRequired,
        Roles: T.arrayOf(T.string).isRequired,
        Divisions: T.arrayOf(T.object),
        AlterEgo: T.shape({
            Login: T.string.isRequired,
            DisplayName: T.string.isRequired,
            Roles: T.arrayOf(T.string).isRequired,
            Divisions: T.arrayOf(T.object)
        })
    })
};

module.exports = User;


// WEBPACK FOOTER //
// ./src/types/User.js